import React from 'react';

const IconAnalytcis = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="21.571" height="21.588" viewBox="0 0 21.571 21.588">
    <g id="Group_4011" data-name="Group 4011" transform="translate(0 0)">
      <path id="circle-three-quarters" d="M10.217,21.671A10.216,10.216,0,0,1,9.159,1.294a.959.959,0,0,1,1.058.951v9.21h9.211a.958.958,0,0,1,.953,1.056A10.187,10.187,0,0,1,10.217,21.671Z" transform="translate(0 -0.083)" fill="#1d3853" />
      <path id="circle-quarter" d="M1.566,1.495a.963.963,0,0,1,.742-.242,10.247,10.247,0,0,1,9.1,9.1.961.961,0,0,1-.953,1.058H2.209a.956.956,0,0,1-.958-.958V2.206A.962.962,0,0,1,1.566,1.495Zm1.6,8H9.329A8.342,8.342,0,0,0,3.166,3.337Z" transform="translate(10.153 -1.248)" fill="#1d3853" />
    </g>
  </svg>
);
export default IconAnalytcis;
